var Wallop = require("wallop");
import LossLocationController from "./LossLocation.js";
import InsCarrierController from "./InsCarrier.js";
import AssignmentContactController from "./AssignmentContact.js";
var validation = require('jquery-validation');
var validationAddtlMethods = require("jquery-validation/dist/additional-methods.js");
var scrollTo = require("jquery.scrollto");
var GoogleAddressField = require("../../../../scripts/classes/GoogleAddressField");
import Bugsnag from '@bugsnag/js'


var SubmitAssignment = function(options){

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

// this function determines which portion of the form should be shown and shows it
SubmitAssignment.prototype.updateFormView = function() {

	if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'yes' )
	{
		$('.js-ins-rel-assign-no').hide();
		$('.js-ins-rel-assign-yes').show();

		// show submit button
		this.options.$el.find('#submit-btn').removeClass('hidden');
	}
	else if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'no' )
	{
		$('.js-ins-rel-assign-yes').hide();
		$('.js-ins-rel-assign-no').show();

		// show submit button
		this.options.$el.find('#submit-btn').removeClass('hidden');
	}
	console.log('update form view');
	// show first section (it's the same either way)
	this.options.$el.find('section').removeClass('active');
	this.options.$el.find('section#client-contact-info-section').addClass('active');

	// keep the assignment type section active, in case they want to go back and change it
	this.options.$el.find('section#assignment-type-section').addClass('active');

	// reset form classes in case submit button was already pressed
	this.options.$el.find('section.hide-checkmarks').removeClass('hide-checkmarks');
	this.options.$el.find('.sections-open-frozen').removeClass('sections-open-frozen').addClass('section-headings-clickable');



};

// this function updates the independent adjusters section
SubmitAssignment.prototype.updateIndAdjView = function() {
	if ($('#ind-adj').is(':checked')) {
		$('#ind-adj-add-carriers-section').show();
		this.options.$el.find('#statements-of-insurance-wrapper').show();

	}
	else {
		$('#ind-adj-add-carriers-section').hide();
		this.options.$el.find('#statements-of-insurance-wrapper').hide();
	}
};

// this function updates the "type of loss" detail section
SubmitAssignment.prototype.updateTypeOfLossView = function() {
	this.options.$el.find('.type-of-loss-detail-subsection').hide();
	var checkedVal = $('input[type=radio][name="fields[typeOfLoss]"]:checked').val();

	if (checkedVal == 'commercial')
	{
		this.options.$el.find('#type-of-loss-business-detail').show();
	}
	else if (checkedVal == 'other')
	{
		this.options.$el.find('#type-of-loss-other-detail').show();
	}

};

// this function updates the validation rules, based on the value of certain form elements
SubmitAssignment.prototype.updateValidationRules = function() {
	console.log('updateValidationRules called');

	// clear the form
	this.submitAssignFormValidator.resetForm();
	// get the value of the insurance related radio
	var insRelVal = $('input[name="fields[assignmentType]"]:checked').val();

	// clear all rules
	$('#submit-assignment-form input, #submit-assignment-form select, #submit-assignment-form textarea').each(function() {
		$(this).rules('remove');
	});


	if (insRelVal == 'yes') {

		// required fields for 'Yes'
		$('.ins-rel-yes-required').each(function() {
			$(this).rules( "add", {
				required: true
			});
		});

		// zip code fields for 'Yes'
		$('.ins-rel-yes-zip').each(function() {
			$(this).rules( "add", {
				required: true
			});
		});

		// email fields for 'Yes'
		$('.ins-rel-yes-email').each(function() {
			$(this).rules( "add", {
				email: true
			});
		});

		// require the type of loss radio button set
		$('[name="fields[typeOfLoss]"]').rules( "add", {
			required: true
		});

	}
	else {

		// required fields for 'No'
		$('.ins-rel-no-required').each(function() {
			$(this).rules( "add", {
				required: true
			});
		});

		// zip code fields for 'No'
		$('.ins-rel-no-zip').each(function() {
			$(this).rules( "add", {
				required: true
			});
		});

		// email fields for 'No'
		$('.ins-rel-no-email').each(function() {
			$(this).rules( "add", {
				email: true
			});
		});

	}

};

SubmitAssignment.prototype.validateLossLocations = function() {

	var assignmentType = $('[name="fields[assignmentType]"]:checked').val();

	if (assignmentType == 'yes')
	{
		// loss location is required
		var $lossLocsFieldWrap = this.options.$el.find('#loss-locations-table-fields-wrapper');
		var $lossLocsNoProjAddrChkbx = this.options.$el.find('#no-proj-addr');

		if (($lossLocsFieldWrap.find('input').length) ||
			($lossLocsNoProjAddrChkbx.prop("checked")))
		{
			// loss location is filled in
			$('#js-loss-loc-error').hide();
			return true;
		}
		else
		{
			$('#js-loss-loc-error').show();

			return false;
		}

	}
	else
	{
		$('#js-loss-loc-error').hide();
		return true;
	}

	console.log('assignment type ' + $('[name="fields[assignmentType]"]:checked').val());

};

/*
------------------------------------------------------------------------------------------
------------------------------------------------------------------------------------------
------------------------------------------------------------------------------------------
*/

// this opens a section and closes all other sections
SubmitAssignment.prototype.goToSection = function($section) {
	this.options.$el.find('section').removeClass('active');
	$section.addClass('active');
	// clear errors
	this.submitAssignFormValidator.resetForm();
	$('#js-loss-loc-error').hide();
};

// this validates an individual section
// this function has logic for specific sections in it
SubmitAssignment.prototype.isSectionValid = function($section) {

	var self = this;
	var sectionValid = true;

	if ($section.attr('id') == 'loss-locs-section') {
		if (!self.validateLossLocations())
		{
			sectionValid = false;
		}
	}
	else if ($section.attr('id') == 'ind-adj-section') {
		sectionValid = true;
	}
	else if ($section.attr('id') == 'assign-conts-section') {
		sectionValid = true;
	}
	else
	{

		$section.find('input, textarea').each(function() {

			if (!$(this).valid())
			{
				sectionValid = false;
			}

		});

	}

	return sectionValid;

};

// this function goes to the next section
// it takes the currently active section as input
// it should only be run once validation is complete
SubmitAssignment.prototype.nextSection = function($currSection) {

	var self = this;

	// close the current section to prepare to open next section
	$currSection.removeClass('active');

	if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'yes' )
	{
		var $nextSection = $currSection.nextAll('section.js-ins-rel-assign-yes').first();
	}
	else if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'no' )
	{
		var $nextSection = $currSection.nextAll('section.js-ins-rel-assign-no').first();
	}

	if ($nextSection.length) {
		console.log('next section exists');
		// go to next section
		self.goToSection($nextSection);
	}
	else
	{
		// there is no next section, close all sections
		this.options.$el.find('section').removeClass('active');
	}

};


// this function is called when the section changes
// this function updates the validation checkmarks
// this function clears all error messages from the form as well
SubmitAssignment.prototype.updateSectionValidCheckmarks = function() {

	var self = this;

	if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'yes' )
	{
		var sectionSelector = 'section.js-ins-rel-assign-yes';
	}
	else if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'no' )
	{
		var sectionSelector = 'section.js-ins-rel-assign-no';
	}

	self.options.$el.find(sectionSelector).each(function() {

		if (self.isSectionValid($(this)))
		{
			$(this).addClass('validated');
		}
		else
		{
			$(this).removeClass('validated');
		}

	});

	// clear the form errors
	this.submitAssignFormValidator.resetForm();

};

// this function runs when the submit assignment button is pressed
// it validates the full form, and submits if valid
// if invalid, it opens all sections and shows error messages,
// hides the continue buttons and section checkmarks
// then scrolls to the first error
SubmitAssignment.prototype.fullFormValidationSubmit = function() {

	var self = this;

	var $form = this.options.$el.find('form#submit-assignment-form');

	if (self.validateLossLocations())
	{
		var lossLocValid = true;
	}
	else
	{
		var lossLocValid = false;
	}

	if($form.valid() && lossLocValid)
	{

		if (!self.formSubmitted) {

			self.formSubmitted = true;

			// This form posts normally rather than over ajax, so the conversion is
			// GTM's to fire on the resulting thank-you page — nothing to do here.
			$form.submit();

		}
		

	}
	else
	{

		// open all sections
		if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'yes' )
		{
			var sectionSelector = 'section.js-ins-rel-assign-yes';
		}
		else if ( $('input[type=radio][name="fields[assignmentType]"]:checked').val() == 'no' )
		{
			var sectionSelector = 'section.js-ins-rel-assign-no';
		}
		$(sectionSelector).addClass('active');

		//self.options.$el.find('.next-section-btn').hide();
		self.options.$el.find('section').addClass('hide-checkmarks');
		self.options.$el.find('form.section-headings-clickable').removeClass('section-headings-clickable').addClass('sections-open-frozen');

		// scroll to first error
		$(window).scrollTo($('.error').first().closest('section'), 500);

		console.log('form invalid, report to bugsnag');

		// log this event to bugsnag
		//

		var failedValidations = '';

		self.options.$el.find('input.error').each(function() {

			failedValidations += $(this).attr('name') + ', ';

		});

		if (!lossLocValid)
		{
			failedValidations += 'lossLocations';
		}

		Bugsnag.addMetadata('errorInfo', {
			fields: failedValidations
		});

		Bugsnag.notify(new Error('Submit assignment form submitted, but form did not pass validation.'));

	}

};

/**
 * Init'ing our Google Shipping Address Fields
 * !!! N'est plus utiliser !!!
 */
SubmitAssignment.prototype.initGoogleAddressFields = function(){

	var self = this;

	// contact info address
	var $contactInfoAddressField = $("#client-contact-info-addr");

	var contactInfoGoogleAddressField = new GoogleAddressField({
		$addressField: $contactInfoAddressField,
		fields: {
			$address: $("#client-contact-info-addr"),
			$city: $("#client-contact-info-city"),
			$state: $("#client-contact-info-state"),
			$zipcode: $("#client-contact-info-zip")
		},
		callback: function(){

		}
	});

	contactInfoGoogleAddressField.init();

};

/*
------------------------------------------------------------------------------------------
------------------------------------------------------------------------------------------
------------------------------------------------------------------------------------------
*/


SubmitAssignment.prototype.init = function() {

	var self = this;

	this.formSubmitted = false;

	// init bugsnag
	Bugsnag.start('aa489839d6ac578d166a7bb89cae5035');

	$(document).ready(function() {

		// initialize the form validator
		self.submitAssignFormValidator = $('#submit-assignment-form').validate({
			ignore:'',
			rules: {
				"fields[assignmentType]": {
					required: true
				},
				"fields[clientName]": {
					required: true
				}
			},
			errorPlacement: function(error, element) {
				if (element.attr("type") == "text") {
					error.appendTo( element.closest("div.field") );
				}
				else {
					error.appendTo( element.closest("div") );
				}
			}
		});

		/* if this is the spanish site, we need to use a spanish error message */
		if (window.Language == "spanish")
		{
			jQuery.extend(jQuery.validator.messages, {
				required: "Este campo es obligatorio."
			});
		}


		// update our file fields to show what documents are uploaded
		/*
		$("body").on('change', 'input:file', function(){

			var files = $(this).prop("files");
			var filenames = $.map(files, function(val) { return val.name; });
			var filenamesStr = filenames.join(', ');
			$(this).closest('div').siblings(".documents").html(filenamesStr);

		});
		*/

		// when the independent adjusters checkbox is changed, show/hide 'add carriers'
		// #ind-adj-add-carriers-section
		$('#ind-adj').change(function() {
			self.updateIndAdjView();
		});

		// when the "type of loss" radio button is changed, show the appropriate detail textbox
		self.options.$el.find('input[type=radio][name="fields[typeOfLoss]"]').change(function() {
			self.updateTypeOfLossView();
		});

		// when the assignment type field is edited, update the form view
		/*
		$('input[type=radio][name="fields[assignmentType]"]').change(function() {
			self.updateFormView();
		});
		*/


		// update our validation rules when relevant inputs are changed
		$('input[type=radio][name="fields[assignmentType]"]').change(function() {
			self.updateValidationRules();
		});

		// when call or email link is clicked, open call/email modal
		$('#open-call-email-modal').click(function() {

			$('#call-email-modal').show();
			$('#call-email-modal').fadeTo(10, 1);
			$('.modal-overlay').show();
			$('.modal-overlay').fadeTo(10, 1);
		});

		// close the modal when the call/email close button is clicked0
		$('#call-email-modal .close').click(function() {
			$('#call-email-modal').hide();
			$('#call-email-modal').css('opacity', '0');
			$('.modal-overlay').hide();
			$('.modal-overlay').css('opacity', '0');
		});

		// require there to be at least 1 loss location submitted
		$('#submit-btn').click(function() {
			self.fullFormValidationSubmit();
		});

		// update the form view on document ready, so that if box is checked
		// before document loads for view will update
		self.updateFormView();
		self.updateIndAdjView();
		self.updateTypeOfLossView();


		/*
		------------------------------------------------------------------------------------------
		------------------------------------------------------------------------------------------
		------------------------------------------------------------------------------------------
		*/
		// code that manages form sections

		self.options.$el.on('click', '.section-headings-clickable section .form-heading', function() {

			var $section = $(this).closest('section');
			var $activeSection = self.options.$el.find('section.active');

			if (self.isSectionValid($activeSection))
			{
				$activeSection.addClass('validated');
			}
			else {
				$activeSection.removeClass('validated');
			}

			// if going back to the first section, hide the other sections and the submit button
			if ($section.attr('id') == 'assignment-type-section')
			{
				$('.js-ins-rel-assign-no').hide();
				$('.js-ins-rel-assign-yes').hide();

				// hide submit button
				self.options.$el.find('#submit-btn').addClass('hidden');
			}

			self.goToSection($section);


		});



		self.options.$el.find('.next-section-btn button').on('click', function() {

			var $section = $(this).closest('section');

			if ($section.attr('id') == 'assignment-type-section')
			{
				self.updateFormView();
			}

			if (self.isSectionValid($section))
			{
				console.log('section valid');
				$section.addClass('validated');
				self.nextSection($section);
			}
			else
			{
				console.log('section invalid');
				$section.removeClass('validated');
			}



		});

		/*
		------------------------------------------------------------------------------------------
		------------------------------------------------------------------------------------------
		------------------------------------------------------------------------------------------
		*/

		self.options.$el.find('#no-proj-addr').on('change', function() {
			self.validateLossLocations();
		});


		self.initGoogleAddressFields();


	});



	var lossLocationCont = new LossLocationController();
	var InsuranceCarrierCont = new InsCarrierController();
	var AssignmentContactCont = new AssignmentContactController();

};

export default  SubmitAssignment;
